import isValid from "date-fns/isValid";
import parseISO from "date-fns/parseISO";
import { KeyValueParams } from "../../components/filter/datafilter-types";

const isValidISOString = (dateString: string): boolean => {
  const parsed = parseISO(dateString);
  return isValid(parsed);
};

export const encodeKeyValuesParams = (
  params: KeyValueParams | undefined
): Record<string, string | number> => {
  if (!params) {
    return {};
  }

  return params.reduce((acc, param) => {
    if (param.key && param.value !== undefined && param.value !== null) {
      // The backend does not need to encode the datetime string, so we keep the ISO format
      if (isValidISOString(param.value)) {
        return { ...acc, [param.key]: param.value };
      }
      // skip encoding for dosageStrength field. We don't need this
      if (param.key === "dosageStrength") {
        return { ...acc, [param.key]: param.value };
      }
      // skip encoding for globalBrand field in app-authentifield
      if (param.key === "globalBrand") {
        return { ...acc, [param.key]: param.value };
      }
      return { ...acc, [param.key]: encodeURIComponent(param.value) };
    }
    return acc;
  }, {} as Record<string, string | number>);
};
